import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import "../styles/Sign.css";
import toast, { Toaster } from "react-hot-toast";
import SignStyle from "../components/SignStyle";
import SignInput from "../components/SignInput";
import SignButton from "../components/SignButton";
import SignDesc from "../components/SignDesc";

const Signup = () => {
  const [userName, setUserName] = useState("");
  const [errorUserName, setErrorUserName] = useState("");
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { createUser } = UserAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { user } = await createUser(email, password);
      const userRef = doc(db, user.uid, "Data Pengguna");

      const dataPengguna = {
        user_name: userName,
      };
      await setDoc(userRef, dataPengguna);
      toast.success("Akun berhasil dibuat");
      navigate("/");
    } catch (e) {
      toast.error("Akun gagal dibuat");
    }
  };

  const isUserNameValid = (password) => {
    return password.length >= 2;
  };

  const addUserName = (e) => {
    const newUserName = e.target.value;
    setUserName(newUserName);

    if (!isUserNameValid(newUserName)) {
      setErrorUserName(true);
    } else {
      setErrorUserName(false);
    }
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrorEmail(!validateEmail(e.target.value));
  };

  const isPasswordValid = (password) => {
    return password.length >= 6;
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    if (!isPasswordValid(newPassword)) {
      setErrorPassword(true);
    } else {
      setErrorPassword(false);
    }
  };

  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="root-sign">
      <div className="sign-wrapper">
        <div className="sign-form__wrapper">
          <h1 className="sign-form__judul">Daftar</h1>
          <form
            onSubmit={handleSubmit}
            className="sign-form"
            name="signup-form"
          >
            <div className="sign-form__detail">
              <SignDesc statusAcc="Sudah" textLink="Masuk" to="/" />
              <SignInput
                sign="username"
                signLabel="User Name"
                typeInput="text"
                onChange={addUserName}
                autoComplete="username"
                errCondition={errorUserName}
              />

              <SignInput
                sign="email"
                signLabel="Email"
                onChange={handleEmailChange}
                autoComplete="email"
                typeInput="email"
                errCondition={errorEmail}
              />

              <SignInput
                sign="password"
                signLabel="Password"
                onChange={handlePasswordChange}
                autoComplete="current-password"
                placeholder="kata sandi minimal 6 karakter"
                typeInput={showPassword ? "text" : "password"}
                passwordIcon={
                  showPassword ? (
                    <FiEye
                      onClick={handleToggleShowPassword}
                      className="icon-eye__open icon-eye"
                    />
                  ) : (
                    <FiEyeOff
                      onClick={handleToggleShowPassword}
                      className="icon-eye__close icon-eye"
                    />
                  )
                }
                errCondition={errorPassword}
              />
            </div>

            <SignButton text="Daftar" />
          </form>
        </div>
        <SignStyle />
      </div>
      <Toaster />
    </div>
  );
};

export default Signup;
